import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import Breadcrums from "../../common/breadcrumbs";
import * as productManagement from "../../services/productManagement";
import toHtml from "html-react-parser";
import { formateDateWithMonth, formateDateWithMonthAdmin, showStatus, TrimText } from "../../../../utils/commonfunction";
import * as leadsService from "../../services/leads.services";

const ViewLeads = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    console.log(showdefault, "showdefaultttt");

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: t("sidebar_link_leads"),
            url: "/admin/leads/list/1",
        },
        { title: t("btn_view"), url: "" },
    ];

    useEffect(() => {
        let id = params.id;
        const formdata = new FormData();
        formdata.append("_id", id);
        leadsService
            .Details(formdata)
            .then((response) => {
                console.log("View response-123", response);
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">
                                    {t('sidebar_link_stream')}
                                </h6>
                            </div>
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>

                                                <tr>
                                                    <th>{t("label_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault?.product?.title
                                                            ? <div className="d-flex capitalize">{TrimText(showdefault?.product?.title, 20)}</div>
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                               

                                                <tr>
                                                    <th>{t("label_brand")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.product?.brand
                                                            ? <div className="d-flex capitalize">{TrimText(showdefault?.product?.brand, 20)}</div>
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_category")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.product?.category
                                                            ? <div className="d-flex capitalize">{TrimText(showdefault?.product?.category, 20)}</div>
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_description")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.product?.description
                                                            ? <div className="d-flex capitalize">{TrimText(showdefault?.product?.description, 20)}</div>
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                   <tr>
                                                    <th>{t("label_seller")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.seller?.name
                                                            ? <div className="d-flex capitalize">{TrimText(showdefault?.seller?.name, 20)}</div>
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_store_name")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.seller?.store_name
                                                            ? <div className="d-flex capitalize">{showdefault?.seller?.store_name}</div>
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                   <tr>
                                                    <th>{t("label_buyer")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.buyer?.name
                                                            ? <div className="d-flex capitalize">{TrimText(showdefault?.buyer?.name, 20)}</div>
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                              
                                               
                                                <tr>
                                                    <th>{t("label_image")}</th>
                                                    <td>
                                                        <img
  src={
    showdefault?.product?.frames?.length > 0
      ? showdefault.product.frames[0].frame_url
      : showdefault?.product?.image || ""
  }
  alt={showdefault?.product?.title || "product"}
  style={{ height: "100px" }}
/>
</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("list_heading_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.createdAt
                                                            ? formateDateWithMonthAdmin(showdefault.createdAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                        </div>


                        <div className="mt-5 back-button">
                            <button
                                className="btn ripple btn-dark"
                                type="button"
                                onClick={() =>
                                    navigate("/admin/stream/list/1")
                                }
                            >
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                {t("btn_back")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewLeads;
